import { AnchorHTMLAttributes } from "react";
import { IconType } from "../../foundations/Icons/types";
import Icon from "../../foundations/Icons/Icon";
import { tv } from "tailwind-variants";
import { useLinkClickHandler } from "../../navigation";

interface NavElementProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  /** Highlights the element as the current navigation target. */
  isActive?: boolean;
  leftIcon?: IconType;
  rightIcon?: IconType;
  children?: React.ReactNode;
  size?: "md" | "sm";
}

const styles = tv({
  base: "flex items-center bg-white hover:bg-grey-2 gap-2 font-medium text-black text-md rounded-4 transition-colors h-16 w-58 px-6",
  variants: {
    size: {
      md: "h-16",
      sm: "h-12",
    },
    isActive: {
      true: "font-semibold bg-grey-2",
    },
  },
});

export default function NavElement({
  leftIcon,
  rightIcon,
  children,
  size = "md",
  isActive = false,
  href,
  onClick,
  className,
  ...props
}: NavElementProps) {
  const handleClick = useLinkClickHandler(href, onClick);
  return (
    <li>
      <a
        {...props}
        href={href}
        onClick={handleClick}
        aria-current={isActive ? "page" : undefined}
        className={styles({ isActive, size, className })}
      >
        {leftIcon && <Icon icon={leftIcon} className="size-5" size="sm" />}
        {children}
        {rightIcon && <Icon icon={rightIcon} className="size-5" size="sm" />}
      </a>
    </li>
  );
}
